import React, { useState } from 'react';
import PageShell, { PageHeader, Flourish } from '../common/PageShell';
import { colors, layout, motion, space, type } from '../../styles/tokens';

const links = [
  { label: 'Email', value: 'ysb4@yale.edu', href: 'mailto:ysb4@yale.edu' },
  { label: 'LinkedIn', value: '/in/yanga-booker', href: 'https://www.linkedin.com/in/yanga-booker' },
  { label: 'GitHub', value: '@YangaB7', href: 'https://github.com/YangaB7' }
];

const ContactLink = ({ label, value, href, external }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <a
      href={href}
      {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: 'flex',
        alignItems: 'baseline',
        gap: space[2],
        padding: `${space[2]} 0`,
        borderBottom: `1px solid ${colors.hairline}`,
        textDecoration: 'none',
        color: colors.ink,
        transition: `color ${motion.fast} ease`
      }}
    >
      <span style={{ ...type.label, minWidth: '80px' }}>{label}</span>
      <span
        style={{
          ...type.body,
          color: hovered ? colors.inkStrong : colors.muted,
          transition: `color ${motion.fast} ease`
        }}
      >
        {value}
      </span>
      <span
        style={{
          ...type.meta,
          marginLeft: 'auto',
          display: 'inline-block',
          transition: `transform ${motion.fast} ease`,
          transform: hovered ? 'translateX(3px)' : 'translateX(0)'
        }}
      >
        →
      </span>
    </a>
  );
};

const ContactPage = () => (
  <PageShell>
    <PageHeader title="Contact" subtitle="Let's connect" flourish="✉" />

    <p style={{ ...type.body, maxWidth: layout.prose, marginBottom: space[5] }}>
      I'm always interested in talking about <em>product</em>, <em>AI tools</em>,{' '}
      <em>fromsoft games</em>, or potential collaboration opportunities.
    </p>

    <div style={{ maxWidth: layout.prose }}>
      {links.map((l) => (
        <ContactLink key={l.label} {...l} />
      ))}
    </div>

    <p style={{ ...type.meta, marginTop: space[6] }}>
      <Flourish tone={colors.sageLight}>※</Flourish>
      Built with care
    </p>
  </PageShell>
);

export default ContactPage;
